export const SET_VIEW_MODE = 'view-mode/SET';

export const setViewMode = payload => ({ type: SET_VIEW_MODE, payload });
